<template>
  <!-- SPLASH SCREEN -->
  <div v-if="showSplash" class="splash-screen">
    <img src="@/assets/img/logo/logowarna.png" class="splash-logo" alt="Logo" />
  </div>

  <!-- MAIN CONTENT -->
  <div v-show="!showSplash">
    <HeaderC />
    <NewsFlash />
    <router-view />
    <FooterComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderC from '@/components/NavbarNewC.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import NewsFlash from './components/NewsFlash.vue';

import { ref,onMounted } from "vue";
onMounted(() => {
  console.log("Bootstrap Collapse:", window.bootstrap?.Collapse);
});

export default {
  name: 'App',
  components: {
    HeaderC,
    NewsFlash,
    FooterComponent,
  },
  setup() {
    const showSplash = ref(true);

    onMounted(() => {
      // Splash tampil 1.8 detik
      setTimeout(() => {
        showSplash.value = false;
      }, 1800);
    });

    return { showSplash };
  }
};
</script>

<style>
/* Styling untuk multi-level dropdown */
.dropdown-menu .dropdown-menu {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  top: 0;
  left: 100%;
  position: absolute;
  min-width: 12rem;
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > .dropdown-menu {
  display: none;
}

.dropdown-submenu:hover > .dropdown-menu,
.dropdown-submenu:focus-within > .dropdown-menu {
  display: block;
}

.dropdown-submenu > a::after,
.dropdown-submenu > .dropdown-toggle::after {
  content: "▶";
  float: right;
  margin-left: 0.5rem;
}

/* FULLSCREEN SPLASH */
.splash-screen {
  position: fixed;
  inset: 0;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  animation: fadeOut 0.6s ease forwards;
  animation-delay: 1.3s;
}

/* LOGO ANIMATION */
.splash-logo {
  width: 130px;
  opacity: 0;
  animation: zoomIn 1.2s ease forwards;
}

/* Zoom In */
@keyframes zoomIn {
  0% {
    transform: scale(0.4);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Fade Out */
@keyframes fadeOut {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>

<!-- coba dengan dinamic menu -->

<!-- <template>
  <div class="container mt-3">
    <div class="row">
      <div class="col-md-12">
        <dynamic-menu @select-page="onSelectPage" />
      </div>
      <div row>
        <div class="col-md-9">
          <page-view :page="selectedPage" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import DynamicMenu from './components/DynamicMenu.vue';
import PageView from './components/PageView.vue';

export default {
  components: { DynamicMenu, PageView },
  data() {
    return { selectedPage: null };
  },
  methods: {
    onSelectPage(page) {
      this.selectedPage = page;
    }
  }
};
</script> -->
